/**
 *
 */
export class TextValide {
    public static SUBST_PERCENT: string = "&percnt;";
    public static SUBST_QUOTE: string = "&quot;";
    public static SUBST_APOSTROPHE: string = "&145;"; // it has to be like that because, when it is like that &#145, this function getCleanChatText, deletes #, and system doesn't recognize &145
    public static SUBST_NEWLINE: string = "<br />";
    public static SUBST_BACKSLASH: string = "%5C";

    public static invalidChars: any[] = ["%", "&", "*", "/", "(", ")", "[", "]", "{", "}", "\"", "'", "\\", "´", "`", "^", "°", "§", "€", "²", "³", ",", ";", "µ", "$"];
    public static invalidChatChars: any[] = ["\\+", "#", "<", ">", '"', "\\$"];
    public static invalidUsernameChars: any[] = ["!", "=", "?", "+", "#", "<", ">", "|"];

    constructor() {
    }

    /**
     * returns whether the text is Smartfox validated
     * text must not be empty and not contain chars of the invalidChars array
     */
    public static isSmartFoxValide(value: string): boolean {
        if (value.trim() == "") {
            return false;
        }

        for (let char of TextValide.invalidChars) {
            if (value.indexOf(char) >= 0) {
                return false;
            }
        }
        return true;
    }

    /**
     * returns whether the text is a valid username
     * text must not be empty and not contain chars in "invalidChars" and "invalidUsernameChars"
     */
    public static isUsernameValide(value: string): boolean {
        if (process.env.DEBUG) {
            value = value.replace("|", "");
        }

        if (value.trim() == "") {
            return false;
        }

        if (!TextValide.isSmartFoxValide(value)) {
            return false;
        }

        for (let char of TextValide.invalidUsernameChars) {
            if (value.indexOf(char) >= 0) {
                return false;
            }
        }
        return true;
    }

    /**
     * returns a text without all Server invalid username chars
     * remove invalidUsernameChars
     */
    public static getValidUsername(value: string): string {
        for (let char of TextValide.invalidUsernameChars) {
            let pattern: RegExp = new RegExp("\\" + char, "gim"); //NOPMD
            value = value.replace(pattern, "");
        }
        for (let char2 of TextValide.invalidChars) {
            let pattern2: RegExp = new RegExp("\\" + char2, "gim"); //NOPMD
            value = value.replace(pattern2, "");
        }
        return TextValide.getValideSmartFoxText(value);
    }

    /**
     * returns a String of invalide Smartfoxcharacters or a empty String
     */
    public static getSmartFoxInvalideChar(value: string): string {
        let result: string = "";

        if (value.trim() == "") {
            return result;
        }

        for (let char of TextValide.invalidChars) {
            if (value.indexOf(char) >= 0) {
                result += char;
            }
        }
        return result;
    }

    /**
     * return a text without all Server invalid chars
     * remove invalidChars
     */
    public static getCleanText(value: string): string {
        for (let char of TextValide.invalidChars) {
            let pattern: RegExp = new RegExp("\\" + char, "gim"); //NOPMD
            value = value.replace(pattern, "");
        }
        return TextValide.getValideSmartFoxText(value);
    }

    /**
     * return a text without all PersistanceDateMap invalid chars
     * remove invalidChatChars
     */
    public static getCleanChatText(value: string): string {
        for (let char of TextValide.invalidChatChars) {
            let pattern: RegExp = new RegExp("\\" + char, "gm"); //NOPMD
            value = value.replace(pattern, "");
        }
        return TextValide.getValideSmartFoxText(value);
    }

    /**
     * return a Smartfox validated text
     * remove "%" and "'"
     */
    public static getValideSmartFoxText(value: string): string {
        let pattern1: RegExp = /%/g;
        let pattern2: RegExp = /'/g;
        value = value.replace(pattern1, TextValide.SUBST_PERCENT);
        value = value.replace(pattern2, "");
        return value;
    }

    /**
     * return a Smartfox validated text
     * replace "%", "'" and """
     */
    private static pattern1: RegExp = /%/g;
    private static pattern2: RegExp = /'/g;
    private static pattern3: RegExp = /"/g;
    private static pattern4: RegExp = /\r/g;
    private static pattern5: RegExp = /\\/g;
    private static pattern6: RegExp = /\n/g;
    private static pattern7: RegExp = /\t/g;
    public static getValideSmartFoxJSONTextMessage(value: string): string {
        value = value.replace(TextValide.pattern1, TextValide.SUBST_PERCENT);
        value = value.replace(TextValide.pattern2, TextValide.SUBST_APOSTROPHE);
        value = value.replace(TextValide.pattern3, TextValide.SUBST_QUOTE);
        value = value.replace(TextValide.pattern4, TextValide.SUBST_NEWLINE);
        value = value.replace(TextValide.pattern5, TextValide.SUBST_BACKSLASH);
        value = value.replace(TextValide.pattern6, TextValide.SUBST_NEWLINE);
        value = value.replace(TextValide.pattern7, " ");
        return value;
    }

    public static parseChatMessage(msgText: string): string {
        let pattern1: RegExp = /&percnt;/g;
        msgText = msgText.replace(pattern1, "%");
        return msgText;
    }

    public static parseChatJSONMessage(msgText: string): string {
        if (!msgText) {
            return "";
        }
        let pattern1: RegExp = /&percnt;/g;
        let pattern2: RegExp = /&quot;/g;
        let pattern3: RegExp = /&145;/g;
        let pattern4: RegExp = /<br \/>/g;
        let pattern5: RegExp = /%5C/g;
        let pattern6: RegExp = /(\[|\])/g;
        msgText = msgText.replace(pattern1, "%").replace(pattern2, "\"").replace(pattern3, "'").replace(pattern4, "\n").replace(pattern5, "\\").replace(pattern6, " ");
        return msgText;
    }

    public static isEmailString(emailString: string): boolean {
        let validEmailRegExp: RegExp = /^[A-Za-z0-9\-+_]+(\.[A-Za-z0-9\-+_]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,}$/;
        return validEmailRegExp.test(emailString);
    }

    /**
     * Removes whitespaces from the front and end of the password String
     *
     * @param passwd
     * @return
     */
    public static trimPassword(passwd: string): string {
        return passwd.trim();
    }
}
